import { render, staticRenderFns } from "./AcusesPDF.vue?vue&type=template&id=037c20ca&scoped=true&"
import script from "./AcusesPDF.vue?vue&type=script&lang=js&"
export * from "./AcusesPDF.vue?vue&type=script&lang=js&"
import style0 from "./AcusesPDF.vue?vue&type=style&index=0&id=037c20ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c20ca",
  null
  
)

export default component.exports